module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"numbers":{"days":"<span class=\u0027number\u0027>{n}</span> day|<span class=\u0027number\u0027>{n}</span> days"},"fromArticle":"From article","seeTextReuseCluster":"Compare passages in cluster","textReuseClusterSummary":"Cluster size: {clusterSize} with {lexicalOverlap} over {timespan}."}}')
  delete Component.options._Ctor
}
